export const ANALYTICS_CONSENT_STORAGE_KEY = 'calensync-analytics-consent';

export function grantAnalyticsConsent(): void {
    if (typeof window === 'undefined' || !window.gtag) {
        return;
    }
    window.gtag('consent', 'update', { analytics_storage: 'granted' });
}
